import { jobTypes } from '../reducer/jobsReducer';

export const isEditMetodo = (payload) => ({
  type: jobTypes.JOBEDIT,
  payload,
});


export const jobViewAction = (payload) =>(
  {
    type: jobTypes.jobsALL,
    payload
  }
)

export default null;
